export const TRADE_DRAFT_VERSION = 1;
export const TRADE_DRAFT_TTL_MS = 24 * 60 * 60 * 1000;

export interface PostTradeDraftPayload {
  version: number;
  updatedAt: number;
  formData: Record<string, unknown> & {
    sourceContext?: string | null;
    frontImageUrl?: string;
    backImageUrl?: string;
  };
  selectedCard: Record<string, unknown> | null;
}

export function getPostTradeDraftKeys(userId?: string | number | null) {
  const scope = userId || "guest";
  return {
    storageKey: `postTradeDraft:${scope}`,
    imageKey: `postTradeDraftImage:${scope}`,
  };
}

export function readPostTradeDraft(storageKey: string): PostTradeDraftPayload | null {
  const serializedDraft = sessionStorage.getItem(storageKey);
  if (!serializedDraft) return null;

  try {
    const parsed = JSON.parse(serializedDraft);
    if (!parsed || typeof parsed !== "object") return null;
    return parsed as PostTradeDraftPayload;
  } catch {
    return null;
  }
}

export function writePostTradeDraft(
  storageKey: string,
  formData: Record<string, unknown>,
  selectedCard: Record<string, unknown> | null,
) {
  sessionStorage.setItem(
    storageKey,
    JSON.stringify({
      version: TRADE_DRAFT_VERSION,
      updatedAt: Date.now(),
      formData: { ...formData, photoUrl: "" },
      selectedCard: selectedCard || null,
    } satisfies PostTradeDraftPayload),
  );
}
